<div class="popup-header"> {{data.formData.title}}</div>

<form #f="ngForm">
  <div mat-dialog-content>
    <div class="alert alert-danger" *ngIf="submitError">{{ submitError }}</div>
    <br>
    <div *ngFor="let inputValue of data.formData.inputFeilds" class="input-group  mb-3">

      <div class="input-group-prepend optionalstuff" *ngIf="inputValue.type != 'checkbox'">
        <span class="input-group-text" id="inputGroup-sizing-sm">{{inputValue.labelName}}</span>

      </div>
      <!-- a checkbox reads as "[ ] label", not as a wide input with a tiny box -->
      <label *ngIf="inputValue.type == 'checkbox'" class="popup-check">
        <input type="checkbox" [id]="inputValue.name" [name]="inputValue.name" [ngModel]="inputValue.value"
          [disabled]="inputValue.disabled">
        <span>{{inputValue.labelName}}</span>
      </label>
      <input *ngIf="inputValue.type == 'text' || inputValue.type ==  'number' || inputValue.type == 'color' || inputValue.type == 'password'"
        [placeholder]="inputValue.labelName" [type]="inputValue.type" [id]="inputValue.name" class="form-control"
        aria-label="Small" [name]="inputValue.name" [ngModel]="inputValue.value" aria-describedby="inputGroup-sizing-sm"
        [disabled]="inputValue.disabled" [required]="inputValue.required" />
      <div class="input-group-append" *ngIf="inputValue.lookup">
        <button type="button" class="btn btn-outline-secondary" (click)="runLookup(inputValue, f)"
          [disabled]="lookupLoading">{{ lookupLoading ? 'Looking up…' : (inputValue.lookup.buttonLabel || 'Look up') }}</button>
      </div>
      <!-- <div>
        <mat-hint>{{inputValue.specialText}}</mat-hint>
      </div> -->
      <!-- <app-product-picker [value]="selectedProduct" (onValueChange)="onProductSelected($event)" class="form-control form-control-product" *ngIf="inputValue.type == 'product-select'"></app-product-picker> -->

      <select *ngIf="inputValue.type == null" class="custom-select" [required]="inputValue.required !== false" [name]="inputValue.name"
        [ngModel]="inputValue.value" [id]="inputValue.name">
        <option *ngFor="let option of inputValue.selectOptions" [selected]="inputValue.value == option.value"
          [value]="option.value">{{option.label}}</option>
      </select>

      <mat-form-field *ngIf="data.formData.autoCom" class="example-full-width">

        <input type="text" aria-label="Number" matInput class="form-control" [name]="inputValue.name"
          [ngModel]="inputValue.value" (keyup)="applyFilter($event.target['value'])" [matAutocomplete]="auto">
        <input type="hidden" name="autComObj" [ngModel]="autComObj">

        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" (click)="autComObj = option"
            value="{{option.name}}">
            <span>{{option.name}}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>


      <small class="popup-hint" *ngIf="inputValue.hint">{{ inputValue.hint }}</small>

    </div>


  </div>

  <div mat-dialog-actions align="end">
   
    <button class="theme-button" *ngFor="let button of data.formData.buttons" [type]="button.type"
      (click)="close(button.type === 'submit' ? f : button.name)" mat-raised-button
      [disabled]="(button.validate ? !f.valid : false) || submitting">{{ submitting ? 'Please wait…' : button.name }}</button>
      <button type="button" mat-raised-button [disabled]="submitting" (click)="onNoClick()">Cancel</button>
  </div>
</form>
<!-- {
  title:"Add System",
  inputFeilds:[
    {
      labelName : "System ID",
      name:"systemId",
      required: true,
      specialText : "For this please check documentation of system."
    },
    {
      labelName : "System Name",
      name:"name",
      required: true,
      specialText : ""
    },
    {
      labelName : "Description",
      name:"description",
      required: true,
      specialText : ""
    }
  ],
  buttons : [
    {
      name: "ADD",
      type:"submit",
      color:"primary"
    }
  ]
} -->